'use client';

import React, { useEffect, useRef, useState } from 'react';
import Image from 'next/image';

export default function LoadingScreen() {
  const [visible, setVisible] = useState(true);
  const barRef = useRef<HTMLDivElement>(null);
  const screenRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!barRef.current || !screenRef.current) return;
    const bar = barRef.current;
    const screen = screenRef.current;

    let start: number | null = null;
    const duration = 1200;

    const animate = (timestamp: number) => {
      if (!start) start = timestamp;
      const progress = Math.min((timestamp - start) / duration, 1);
      bar.style.transform = `scaleX(${progress})`;

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setTimeout(() => {
          screen.style.opacity = '0';
          screen.style.pointerEvents = 'none';
          setTimeout(() => setVisible(false), 600);
        }, 200);
      }
    };

    requestAnimationFrame(animate);
  }, []);

  if (!visible) return null;

  return (
    <div data-component-id="src/app/components/LoadingScreen.tsx:41:4" data-component-path="src/app/components/LoadingScreen.tsx" data-component-line="41" data-component-end-line="69" data-component-file="LoadingScreen.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22loading-screen%22%7D"
      ref={screenRef}
      className="loading-screen"
      style={{ transition: 'opacity 0.6s cubic-bezier(0.16,1,0.3,1)' }}
    >
      <div data-component-id="src/app/components/LoadingScreen.tsx:46:6" data-component-path="src/app/components/LoadingScreen.tsx" data-component-line="46" data-component-end-line="68" data-component-file="LoadingScreen.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%20gap-6%22%7D" className="flex flex-col items-center gap-6">
        {/* College Logo */}
        <Image data-component-id="src/app/components/LoadingScreen.tsx:48:8" data-component-path="src/app/components/LoadingScreen.tsx" data-component-line="48" data-component-end-line="55" data-component-file="LoadingScreen.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%2Fassets%2Fimages%2FRP-college-favicon.png%22%2C%22alt%22%3A%22Shri%20R.%20P.%20College%20of%20Pharmacy%20Logo%22%2C%22className%22%3A%22object-contain%22%7D"
          src="/assets/images/RP-college-favicon.png" // Replace with your image path
          alt="Shri R. P. College of Pharmacy Logo"
          width={100}
          height={100}
          priority
          className="object-contain"
        />

        <p data-component-id="src/app/components/LoadingScreen.tsx:57:8" data-component-path="src/app/components/LoadingScreen.tsx" data-component-line="57" data-component-end-line="59" data-component-file="LoadingScreen.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-serif%20text-2xl%20text-foreground%20tracking-tight%20text-center%22%2C%22textContent%22%3A%22Shri%20R.%20P.%20College%20of%20Pharmacy%22%7D" className="font-serif text-2xl text-foreground tracking-tight text-center">
          Shri R. P. College of Pharmacy
        </p>

        <div data-component-id="src/app/components/LoadingScreen.tsx:61:8" data-component-path="src/app/components/LoadingScreen.tsx" data-component-line="61" data-component-end-line="63" data-component-file="LoadingScreen.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22loading-bar%22%7D" className="loading-bar">
          <div data-component-id="src/app/components/LoadingScreen.tsx:62:10" data-component-path="src/app/components/LoadingScreen.tsx" data-component-line="62" data-component-end-line="62" data-component-file="LoadingScreen.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22loading-bar-fill%22%7D" ref={barRef} className="loading-bar-fill" />
        </div>

        <p data-component-id="src/app/components/LoadingScreen.tsx:65:8" data-component-path="src/app/components/LoadingScreen.tsx" data-component-line="65" data-component-end-line="67" data-component-file="LoadingScreen.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xs%20text-muted-foreground%20tracking-widest%20uppercase%22%2C%22textContent%22%3A%22Excellence%20in%20Education%22%7D" className="text-xs text-muted-foreground tracking-widest uppercase">
          Excellence in Education
        </p>
      </div>
    </div>
  );
}